// Container: maps order items to CartItemCard components.
import { CartItemCard } from "./cart-item-card";
import type { OrderItem } from "./use-pos-cart";
import type { ScanResult } from "@/features/inventory/use-scan-resolve";

interface CartItemListProps {
  items: OrderItem[];
  imageMap: Record<string, string>;
  onUpdateItem: (itemId: string, updates: { qty?: number; discount?: string; note?: string }) => void;
  onRemoveItem: (itemId: string) => void;
  loading?: boolean;
  /** Resolver for serial-first scan — threaded from pos-screen-page via useScanResolve. */
  serialResolver?: (q: string) => Promise<ScanResult>;
  onAttachSerial?: (itemId: string, mergedSerialIds: string[]) => void;
  onDetachSerial?: (itemId: string, remainingSerialIds: string[]) => void;
}

export function CartItemList({
  items,
  imageMap,
  onUpdateItem,
  onRemoveItem,
  loading,
  serialResolver,
  onAttachSerial,
  onDetachSerial,
}: CartItemListProps) {
  if (items.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center text-muted-foreground">
        Chưa có sản phẩm — quét barcode hoặc nhấn F2 để tìm
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      {items.map((item) => (
        <CartItemCard
          key={item.id}
          item={{ ...item, imageUrl: imageMap[item.variantId] }}
          onUpdateQty={(qty) => onUpdateItem(item.id, { qty })}
          onUpdateDiscount={(discount) => onUpdateItem(item.id, { discount })}
          onUpdateNote={(note) => onUpdateItem(item.id, { note })}
          onRemove={() => onRemoveItem(item.id)}
          loading={loading}
          serialResolver={serialResolver}
          onAttachSerial={onAttachSerial}
          onDetachSerial={onDetachSerial}
        />
      ))}
    </div>
  );
}
